import { render, staticRenderFns } from "./JournalList.vue?vue&type=template&id=9981dd1a"
import script from "./JournalList.vue?vue&type=script&lang=js"
export * from "./JournalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports